var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-home"},[_c('site'),(_vm.siteId)?_c('router-view'):_c('div',{staticClass:"click-tip"},[_c('img',{attrs:{"src":require("@/assets/click-tip.svg")}}),_c('p',[_vm._v("点击左侧站点查看详情")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }